import { z } from "zod";
// Lower-case segments (`audit-logs`, `openapi.json`) and `{camelCaseParam}` segments.
const pathPattern = /^(\/([a-z0-9][a-z0-9.-]*|\{[A-Za-z]\w*\}))+$/;
/** Checks the path shape and that `{params}` in the path match the `params` schema's keys. */
export function defineEndpoint(definition) {
    if (!pathPattern.test(definition.path))
        throw new Error(`Invalid endpoint path ${definition.path}`);
    const inPath = [...definition.path.matchAll(/\{(\w+)\}/g)].map((m) => m[1] ?? "").sort();
    const shape = definition.params instanceof z.ZodObject ? Object.keys(definition.params.shape).sort() : [];
    if (inPath.join(",") !== shape.join(",")) {
        throw new Error(`Endpoint ${definition.name}: path params {${inPath.join(",")}} do not match its params schema`);
    }
    if (definition.status === 204 && definition.response !== undefined) {
        throw new Error(`Endpoint ${definition.name}: a 204 has no response body`);
    }
    return definition;
}
/** A UUID path parameter: shared so controllers and contracts validate `:id` the same way. */
export const idParamSchema = z.uuid();
export const idParamsSchema = z.object({ id: idParamSchema });
//# sourceMappingURL=endpoint.js.map